// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4fb8cd90","453":"49225639","732":"cbbfd7e5","977":"1c3567bf"}[chunkId] + ".chunk.js";
};